import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import Table from './table';

class ZldtTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { title, names, tableTits, data, url } = this.props.content;

        return (
            <div className={styles.tab}>
                <div className={styles.title}>{title}</div>
                <div className={styles.box}>
                    {data
                        ? Object.keys(names).map((key, index) => (
                              <Table
                                  key={index}
                                  content={{
                                      name: names[key],
                                      tit: tableTits[key],
                                      data: data[key],
                                      url: url[key],
                                      key,
                                  }}
                                  isOpen={isOpen}
                              />
                          ))
                        : [0, 1, 2, 3].map((key, index) => (
                              <Table
                                  key={index}
                                  content={{
                                      name: names && names[key],
                                      tit: tableTits && tableTits[key],
                                      data: {},
                                      url: url && url[key],
                                      key,
                                  }}
                                  isOpen={isOpen}
                              />
                          ))}
                </div>
            </div>
        );
    }
}

export default errorBoundary(ZldtTable);
